import React, { useEffect, useMemo, useState } from "react";
import VoiceMSearchResult from 'components/LM/Voice/MSearch/VoiceMSearchResult';
import K2Api from 'lib/ajax/K2Api';

const BATCH_SIZE = 100;

function VoicesMSearchResults({ location }) {
	const allTerms = useMemo(() => location.state.terms ?? [], [location.state.terms]);
	const maxSearchResultSize = location.state.maxSearchResultSize ?? 5;
	const [currentPage, setCurrentPage] = useState(1);
	const [results, setResults] = useState([]);
	const [loading, setLoading] = useState(true);

	const totalPages = Math.ceil(allTerms.length / BATCH_SIZE) || 1;

	useEffect(() => {
		let cancelled = false;
		const fetchBatch = async () => {
			setLoading(true);
			const start = (currentPage - 1) * BATCH_SIZE;
			const batchTerms = allTerms.slice(start, start + BATCH_SIZE);
			const k2Api = new K2Api();
			try {
				const response = await k2Api.post('voices/msearch', { terms: batchTerms, size: maxSearchResultSize });
				if (!cancelled) setResults(response.data);
			} catch {
				if (!cancelled) setResults([]);
			}
			if (!cancelled) setLoading(false);
		};

		if (allTerms.length > 0) {
			fetchBatch();
		} else {
			setLoading(false);
		}

		return () => { cancelled = true; };
	}, [currentPage, allTerms, maxSearchResultSize]);

	const handlePageChange = (page) => {
		setCurrentPage(page);
		window.scrollTo({ top: 0, behavior: 'smooth' });
	};

	return (
		<VoiceMSearchResult
			results={results}
			maxSearchResultSize={maxSearchResultSize}
			loading={loading}
			currentPage={currentPage}
			totalPages={totalPages}
			totalTerms={allTerms.length}
			onPageChange={handlePageChange}
			allTerms={allTerms}
			batchSize={BATCH_SIZE}
		/>
	);
}

export default VoicesMSearchResults;
